(function () {
  function getImg(swatch) {
    var card = swatch.closest('.product-card');
    return card ? { card: card, img: card.querySelector('.img-first') } : null;
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.card-family-swatch[data-preview-image]');
    if (!swatch) return;
    var ctx = getImg(swatch);
    if (!ctx || !ctx.img) return;
    var img = ctx.img;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
      var pic = img.closest('picture');
      if (pic) {
        pic.querySelectorAll('source').forEach(function (s) {
          s.dataset.originalSrcset = s.getAttribute('srcset') || '';
        });
      }
    }

    var pic2 = img.closest('picture');
    if (pic2) {
      pic2.querySelectorAll('source').forEach(function (s) {
        s.removeAttribute('srcset');
      });
    }
    img.removeAttribute('srcset');
    img.src = swatch.dataset.previewImage;
    ctx.card.classList.add('is-swatch-previewing');
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.card-family-swatch');
    if (!swatch) return;
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;
    var ctx = getImg(swatch);
    if (!ctx || !ctx.img || !ctx.img.dataset.originalSrc) return;
    var img = ctx.img;

    var pic = img.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach(function (s) {
        if (s.dataset.originalSrcset) s.setAttribute('srcset', s.dataset.originalSrcset);
      });
    }
    if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
    img.src = img.dataset.originalSrc;
    ctx.card.classList.remove('is-swatch-previewing');
  });
})();